export default __webpack_public_path__ + "static/media/QLC.300a919b.svg";